import { REQUEST_UPITI} from '../../const';

export default function UpitReducer(state = [], action) {
  switch (action.type) {
      case REQUEST_UPITI:
      return action.upiti;
    default:
      return state;
  }
}